import { useGetRegisterCompositionQuery } from '@schooly/api';
import { FC, PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { ModalAccessDeniedFallback } from '../../../components/Guards';
import useSchoolYears from '../../../hooks/useSchoolYears';
import { isRegisterDateEditable } from '../permissions';

export const RegisterEditableGuard: FC<PropsWithChildren> = ({ children }) => {
  const { id = '' } = useParams();
  const { defaultValidity } = useSchoolYears();
  const { data: composition } = useGetRegisterCompositionQuery(id, { enabled: !!id });

  if (!composition || !defaultValidity) return null;

  if (!isRegisterDateEditable(composition.register_date, defaultValidity)) {
    return <ModalAccessDeniedFallback redirectTo={`/attendance/${id}`} />;
  }

  return <>{children}</>;
};
